import { useDebounceFunc } from "@hook";

import CopyTagUI from "@UI/CopyTagUI";
import { inject, observer } from "mobx-react";
import { Editor } from "primereact/editor";
import { useState, useEffect } from "react";

import "./style.scss";

const HtmlText = inject("mainStore")(
    observer(({ dataId, item, keyData, isDisabled, value, handleDataChange, error = false }) => {
        const [textHtml, setTextHtml] = useState(null);
        const [text, setText] = useState(null);

        useEffect(() => {
            if (!textHtml && value) {
                setTextHtml(String(value).replace(/\&amp;nbsp;/gi, "&nbsp;"));
            }
        }, [value]);

        useEffect(() => {
            if (textHtml !== null) debouncedSet();
        }, [textHtml]);

        const debouncedSet = useDebounceFunc((e) => {
            let valueOut = textHtml ? textHtml : "";
            valueOut = valueOut.replace(/\&amp;nbsp;/gi, "&nbsp;");
            handleDataChange(valueOut, dataId.join("."));
        }, 500);

        return (
            <div key={keyData} className={`detail__item htmltext ${item.addClass ? item.addClass : "full"}`}>
                <label className={dataId.join("-")} htmlFor={keyData} data-pr-tooltip={item.label}>
                    {item.label}
                    {item.required ? "*" : ""}
                </label>
                <Editor
                    data-id={dataId.join(".")}
                    id={keyData}
                    onTextChange={(e) => {
                        if (e.source !== "api") {
                            setTextHtml(e.htmlValue || "");
                            setText(e.textValue || "");
                        }
                    }}
                    style={error ? { border: "1px solid red", height: "320px" } : { height: "320px" }}
                    placeholder={item.placeholder}
                    readOnly={isDisabled}
                    value={textHtml}
                    headerTemplate={item.header ? item.header() : null}
                />
                {item.maxLength ? (
                    <span className={`input-ui__max-length ${value.length > item.maxLength ? "input-ui__max-length_red" : ""}`}>
                        {value.replace(/<\/?[^>]+(>|$)/g, "").length} / <span className="input-ui__max-length_gray">{item.maxLength}</span>
                    </span>
                ) : null}
                {item.copyTag ? <CopyTagUI label={item.copyTag} copyLabel={item.copyLabel} className="copy-tag_small" /> : null}
                {item.text ? <span style={{ color: "#37404C", fontStyle: "italic" }}>{item.text}</span> : null}
            </div>
        );
    }),
);
export default HtmlText;
